<template>
    <div class="container">
        <h1 class="title">Dashboard</h1>
        <div class="columns is-multiline">
            <div class="column is-4">
                <div class="box"
                     :style="[userPermissions.includes('Schedule.ViewAll') ? {'background-color': backgroundColor.full} : {'background-color': backgroundColor.no}]">
                    <router-link :to="{ name: 'Schedule',  params: {date: currentDate}}">
                        <article class="media">
                            <div class="media-left">
                                <figure class="image is-64x64">
<!--                                    <img src="https://image.flaticon.com/icons/svg/2928/2928733.svg" alt="Image">-->
                                    <img src="../../assets/svg/2928733.svg" alt="image">
                                </figure>
                            </div>
                            <div class="media-content">
                                <div class="container">
                                    <div class="level">
                                        <div class="level-left">
                                            <p class="is-size-5">Schedule</p>
                                        </div>
                                        <div class="level-right">
                                            <figure class="image is-64x64 ">
                                                <img src="../../assets/svg/2698315.svg" alt="image">
<!--                                                <img src="https://image.flaticon.com/icons/svg/2698/2698315.svg" alt="Image">-->
                                            </figure>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </article>
                    </router-link>
                </div>
            </div>

            <div class="column is-4">
                <div class="box" :style="[userPermissions.includes('Flights.View') ? {'background-color': backgroundColor.full} : {'background-color': backgroundColor.no}]">
                    <router-link :to="{ name: 'Flights' }">
                    <article class="media">
                        <div class="media-left">
                            <figure class="image is-64x64">
                                <img src="../../assets/svg/3022931.svg" alt="image">
<!--                                <img src="https://image.flaticon.com/icons/svg/3022/3022931.svg" alt="Image">-->
                            </figure>
                        </div>
                        <div class="media-content">
                            <div class="container">
                                <div class="level">
                                    <div class="level-left">
                                        <p class="is-size-5">Flights</p>
                                    </div>
                                    <div class="level-right">
                                        <figure class="image is-64x64 is-danger">
                                            <img src="../../assets/svg/2698315.svg" alt="image">
<!--                                            <img src="https://image.flaticon.com/icons/svg/2698/2698315.svg"-->
<!--                                                 alt="Image">-->
                                        </figure>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </article>
                    </router-link>
                </div>
            </div>

            <div class="column is-4">
                <div class="box"
                     :style="[userPermissions.includes('Efb.Device') ? {'background-color': backgroundColor.full} : {'background-color': backgroundColor.no}]">
                    <router-link :to="{ name: 'Efb' }">
                        <article class="media">
                            <div class="media-left">
                                <figure class="image is-64x64">
                                    <img src="../../assets/svg/tablet-ipad-efb.svg" alt="Image">
<!--                                    <img src="https://image.flaticon.com/icons/svg/2819/2819932.svg" alt="Image">-->
                                </figure>
                            </div>
                            <div class="media-content">
                                <div class="container">
                                    <div class="level">
                                        <div class="level-left">
                                            <p class="is-size-5">EFB Devices</p>
                                        </div>
                                        <div class="level-right">
                                            <figure class="image is-64x64 ">
                                                <img src="../../assets/svg/2698315.svg" alt="image">
<!--                                                <img src="https://image.flaticon.com/icons/svg/2698/2698315.svg" alt="Image">-->
                                            </figure>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </article>
                    </router-link>
                </div>
            </div>

            <div class="column is-4">
                <div class="box"
                     :style="[userPermissions.includes('Aircraft.Full') ? {'background-color': backgroundColor.full} : {'background-color': backgroundColor.no}]">
                    <router-link :to="{ name: 'Aircrafts' }">
                        <article class="media">
                            <div class="media-left">
                                <figure class="image is-64x64">
                                    <img src="../../assets/svg/1358696.svg" alt="image">
<!--                                <img src="https://image.flaticon.com/icons/svg/1358/1358696.svg" alt="Image">                                       -->
                                </figure>
                            </div>
                            <div class="media-content">
                                <div class="container">
                                    <div class="level">
                                        <div class="level-left">
                                            <p class="is-size-5">Aircrafts</p>
                                        </div>
                                        <div class="level-right">
                                            <figure class="image is-64x64 ">
                                                <img src="../../assets/svg/2698315.svg" alt="image">
<!--                                                <img src="https://image.flaticon.com/icons/svg/2698/2698315.svg" alt="Image">                       -->
                                            </figure>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </article>
                    </router-link>
                </div>
            </div>

            <div class="column is-4">
                <div class="box"
                     :style="[userPermissions.includes('Users.View') ? {'background-color': backgroundColor.full} : {'background-color': backgroundColor.no}]">
                    <router-link :to="{ name: 'Users' }">
                        <article class="media">
                            <div class="media-left">
                                <figure class="image is-64x64">
                                    <img src="../../assets/svg/usermanage.svg" alt="">
<!--                                    <img src="https://image.flaticon.com/icons/svg/1556/1556324.svg" alt="Image">-->
                                </figure>
                            </div>
                            <div class="media-content">
                                <div class="container">
                                    <div class="level">
                                        <div class="level-left">
                                            <p class="is-size-5">User Management</p>
                                        </div>
                                        <div class="level-right">
                                            <figure class="image is-64x64 ">
                                                <img src="../../assets/svg/2698315.svg" alt="image">
<!--                                                <img src="https://image.flaticon.com/icons/svg/2698/2698315.svg" alt="Image">-->
                                            </figure>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </article>
                    </router-link>
                </div>
            </div>

            <div class="column is-4">
                <div class="box"
                     :style="[userPermissions.includes('IpadUsers.Full') ? {'background-color': backgroundColor.full} : {'background-color': backgroundColor.no}]">
                    <router-link :to="{ name: 'IpadUserList' }">
                        <article class="media">
                            <div class="media-left">
                                <figure class="image is-64x64">
                                    <img src="../../assets/svg/pilot.svg" alt="image">
<!--                                    <img src="https://image.flaticon.com/icons/svg/3043/3043314.svg" alt="Image">-->
                                </figure>
                            </div>
                            <div class="media-content">
                                <div class="container">
                                    <div class="level">
                                        <div class="level-left">
                                            <p class="is-size-5">Ipad Users</p>
                                        </div>
                                        <div class="level-right">
                                            <figure class="image is-64x64 ">
                                                <img src="../../assets/svg/2698315.svg" alt="image">
<!--                                                <img src="https://image.flaticon.com/icons/svg/2698/2698315.svg" alt="Image">-->
                                            </figure>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </article>
                    </router-link>
                </div>
            </div>

            <div class="column is-4">
                <div class="box"
                     :style="[userPermissions.includes('Airport.Full') ? {'background-color': backgroundColor.full} : {'background-color': backgroundColor.no}]">
                    <router-link :to="{ name: 'Airport' }">
                        <article class="media">
                            <div class="media-left">
                                <figure class="image is-64x64">
                                    <img src="../../assets/svg/2942128.svg" alt="image">
<!--                                    <img src="https://image.flaticon.com/icons/svg/2942/2942128.svg" alt="Image">-->
                                </figure>
                            </div>
                            <div class="media-content">
                                <div class="container">
                                    <div class="level">
                                        <div class="level-left">
                                            <p class="is-size-5">Airports</p>
                                        </div>
                                        <div class="level-right">
                                            <figure class="image is-64x64 ">
                                                <img src="../../assets/svg/2698315.svg" alt="image">
<!--                                                <img src="https://image.flaticon.com/icons/svg/2698/2698315.svg" alt="Image">           -->
                                            </figure>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </article>
                    </router-link>
                </div>
            </div>

            <div class="column is-4">
                <div class="box"
                     :style="[userPermissions.includes('FIRs.Full') ? {'background-color': backgroundColor.full} : {'background-color': backgroundColor.no}]">
                    <router-link :to="{ name: 'firs' }">
                    <article class="media">
                        <div class="media-left">
                            <figure class="image is-64x64">
                                <img src="../../assets/svg/3003501.svg" alt="image">
<!--                                <img src="https://image.flaticon.com/icons/svg/3003/3003501.svg" alt="Image">-->
                            </figure>
                        </div>
                        <div class="media-content">
                            <div class="container">
                                <div class="level">
                                    <div class="level-left">
                                        <p class="is-size-5">FIRs Manage</p>
                                    </div>
                                    <div class="level-right">
                                        <figure class="image is-64x64 ">
                                            <img src="../../assets/svg/2698315.svg" alt="image">
<!--                                            <img src="https://image.flaticon.com/icons/svg/2698/2698315.svg" alt="Image">               -->
                                        </figure>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </article>
                    </router-link>
                </div>
            </div>

            <div class="column is-4">
                <div class="box"
                     :style="[userPermissions.includes('WeatherMatrix.Full') ? {'background-color': backgroundColor.full} : {'background-color': backgroundColor.no}]">
                    <router-link :to="{ name: 'WeatherMatrix' }">
                    <article class="media">
                        <div class="media-left">
                            <figure class="image is-64x64">
                                <img src="../../assets/svg/1163624.svg" alt="image">
<!--                                <img src="https://image.flaticon.com/icons/svg/1163/1163624.svg" alt="Image">-->
                            </figure>
                        </div>
                        <div class="media-content">
                            <div class="container">
                                <div class="level">
                                    <div class="level-left">
                                        <p class="is-size-5">Weather Matrix</p>
                                    </div>
                                    <div class="level-right">
                                        <figure class="image is-64x64 ">
                                            <img src="../../assets/svg/2698315.svg" alt="image">
<!--                                            <img src="https://image.flaticon.com/icons/svg/2698/2698315.svg" alt="Image">           -->
                                        </figure>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </article>
                    </router-link>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import {mapActions, mapState} from "vuex";
    // import ScheduleService from "../../services/schedule.service";

    export default {
        name: "DashboardPage",
        data() {
            return {
                currentDate : '',
                NotamImportantList:[],
                userPermissions: [],
                backgroundColor: {
                    full: 'rgba(181,232,235,0.51)',
                    justRead: 'rgba(220,235,173,0.51)',
                    no: 'rgba(255,43,50,0.51)',
                }
            }
        },
        computed: {
            ...mapState("auth", ["user"]),
        },
        methods: {
            ...mapActions("auth", ["logout"])
        },
        async created() {
            this.currentDate = new Date().toISOString().slice(0, 10);
            this.userPermissions = this.user.permissions;

        }
    }
</script>

<style scoped lang="scss">
    .media-content {
        align-self: center;
    }
</style>
